import { render, staticRenderFns } from "./ManageOverlappingModal.vue?vue&type=template&id=7af666c0&scoped=true&"
import script from "./ManageOverlappingModal.vue?vue&type=script&lang=ts&"
export * from "./ManageOverlappingModal.vue?vue&type=script&lang=ts&"
import style0 from "./ManageOverlappingModal.vue?vue&type=style&index=0&id=7af666c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af666c0",
  null
  
)

export default component.exports